import { ConnectedMessagesPage } from './ConnectedMessagesPage'
import { getMessagesPath } from './paths'

export const routes = [
  {
    path: getMessagesPath(':id'),
    component: ConnectedMessagesPage,
    exact: true
  }
]
